module.exports = __webpack_public_path__ + "img/lagerausbildung-3bohrungen_zzz.69d89d27.jpg";